import { ROUTER_API } from 'app/constants/api.constant';
import { ListObject } from 'app/main/design-system/models/listObjectsModel';
import BaseApi from 'app/services/api/base.api';
import { AverageStoreOpinionsDTO, StoreOpinionDetailsDTO } from '../type';

export const satisfactionApiV2 = new BaseApi({ baseURL: ROUTER_API, tokenKey: 'token', timeout: 60000 });

export const getAverageStoresOpinionsApi = async (includeDisabled: boolean) => {
  const response = await satisfactionApiV2.api.get<ListObject<AverageStoreOpinionsDTO>>('api/v2/stores/opinions', {
    params: {
      includeDisabled,
    },
  });
  return response.data;
};

export const getStoreOpinionsApi = async (storeId: string) => {
  const response = await satisfactionApiV2.api.get<ListObject<StoreOpinionDetailsDTO>>(
    `api/v2/stores/${storeId}/opinions`,
  );
  return response.data;
};
